export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    REGISTER: "/register",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
}

export const NAVIGATE_MODULE = {
    HOME: "/home",
    USER: '/user',
    FEEDBACK: '/feedback',
    get HOME_PAGE() { return `${this.HOME}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}

export const NAVIGATE_ADMIN = {
    ADMIN_USER: "/admin",
    DASHBOARD: "/dashboard",

    MACHINE_LIST: "/machine-list",
    DELETED_MACHINE_LIST: "/machine-history",
    MACHINE_DOCUMENT_LIST: "/machine-documents",

    get DASHBOARD_PAGE() { return `${this.ADMIN_USER}${this.DASHBOARD}`; },
}

